import React, { useEffect } from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  PaginateCarriersState,
} from "store/ducks/settings/carriers";

import * as S from "./styles";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridCarriers, FilterCarriers } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListCarriers: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('carriers')

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateCarriers
  ) as PaginateCarriersState;

  useEffect(() => {
    getData();
  }, [getData]);
  
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")} <MenuSelector page="carriers" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertCarriers") && (
            <S.ButtonMini onClick={() => history.push("/settings/carrier/new")}>
              {getTranslation("novaTransportadora")}
            </S.ButtonMini>
          )}
          <FilterCarriers />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridCarriers carriers={data} />
        <Paginator
          pagination={pagination}
          settingsPage='carriers'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
